// removed by extract-text-webpack-plugin
module.exports = {"classButton":"Button-classButton-fda3550e","classButtonSecondary":"Button-classButtonSecondary-6de2eb21","classButtonTransparent":"Button-classButtonTransparent-198af250","classButtonLarge":"Button-classButtonLarge-10a67edb","classButtonSmall":"Button-classButtonSmall-6ad1fe56"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Button.scss
// module id = 820
// module chunks = 0